import { Chip, styled } from '@mui/material';

const ContentLabel = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.tertiary.main,
  display: 'flex',
  color: theme.palette.primary.blueMid,
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2.421052932739258px 4.263158798217773px',
  height: '23px',
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.smallText.fontSize,
  lineHeight: '12px',
  '&:hover': {
    backgroundColor: theme.palette.primary.blueSky,
    color: theme.palette.primary.blueMid,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    height: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    height: '18px',
    width: 'auto',
  },
}));

const AvatarLabel = styled('img')({
  width: '16px',
  height: '16px',
  objectFit: 'contain',
});

export const MotivationLabel = ({ motivation, motivationsId }) => {
  return (
    <>
      <ContentLabel
        label={motivation}
        avatar={
          <AvatarLabel
            src={`/assets/images/iconProducts/${motivationsId}.svg`}
            style={{ width: '16px', height: '16px' }}
            sx={{
              fontSize: '8px',
              lineHeight: '8px',
              marginTop: '2px',
            }}
          />
        }
      />
    </>
  );
};
